<h1 class="text-light text-weight-light">Account</h1>

<p class="text-light text-weight-light">The account settings page shows the supplier details tied to your account.</p>

<div class="account-options">

    <div class="flex-row account-option-row">
        <div class="account-item flex-1">
            <label for="">Supplier Name </label>
            <input type="text" class="input input-lg" [(ngModel)]="supplier().companyName" disabled>
        </div>

        <div class="account-item flex-1"></div>
    </div>

    <div class="flex-row account-option-row">
        <div class="account-item flex-1">
            <label for="">Supplier ID </label>
            <input type="text" class="input input-lg" [(ngModel)]="supplier().supplierID" disabled>
        </div>

        <div class="account-item flex-1"></div>
    </div>

    <div class="flex-row account-option-row">

        <div class="account-item flex-1">
            <label for="">Email </label>
            <input type="text" class="input input-lg" [(ngModel)]="supplier().email" disabled>
        </div>
     
        <div class="account-item flex-1"></div>
    </div>

    <div class="flex-row account-option-row">
        <div class="account-item flex-1">
            <label for="">Flanders Vendor Number </label>
            <input type="text" class="input input-lg" [(ngModel)]="supplier().flandersVN" disabled>
        </div>

        <div class="account-item flex-1"></div>
    </div>

    <div class="flex-row account-option-row">
        <div class="account-item flex-1">
            <label for="">Swords Vendor Number </label>
            <input type="text" class="input input-lg" [(ngModel)]="supplier().swordsVN" disabled>
        </div>

        <div class="account-item flex-1"></div>
    </div>

    <h3>Email Change</h3>

    <p class="text-light text-weight-light">
        Email change is temporarily unavailable in this migration and has been deprecated for now.
    </p>
</div>

<div class="flex-row sign-out-section">
    <div class="action-button sign-out-button" (click)="signOut()"> Sign Out </div>
</div>
